var _g, _g2, _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _path3, _path4, _g3, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect7, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveScreenFreeMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 147,
    viewBox: "0 0 256 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.771,
    y: 38.6455,
    width: 8.61539,
    height: 22.6154,
    transform: "rotate(6 177.771 38.6455)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.294,
    y: 19.4824,
    width: 47.3846,
    height: 34.4615,
    rx: 2.96154,
    transform: "rotate(6 160.294 19.4824)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.46,
    y: 57.4736,
    width: 17.2308,
    height: 3.23077,
    rx: 1.61538,
    transform: "rotate(6 171.46 57.4736)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.086 25.4004L199.475 48.5062",
    stroke: "white",
    strokeWidth: 2.96154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.06 44.6787L201.501 29.2276",
    stroke: "white",
    strokeWidth: 2.96154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.1729,
    y: 85.6025,
    width: 7.38461,
    height: 19.3846,
    transform: "rotate(9 97.1729 85.6025)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.0723,
    y: 68.415,
    width: 40.6154,
    height: 29.5385,
    rx: 2.53846,
    transform: "rotate(9 83.0723 68.415)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.9268,
    y: 101.436,
    width: 14.7692,
    height: 2.76923,
    rx: 1.38462,
    transform: "rotate(9 90.9268 101.436)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9092 73.6963L115.308 95.0167",
    stroke: "white",
    strokeWidth: 2.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3105 90.1064L117.908 78.6053",
    stroke: "white",
    strokeWidth: 2.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.028,
    y: 84.4287,
    width: 9.84615,
    height: 25.8462,
    transform: "rotate(-4 147.028 84.4287)",
    fill: "#2D2F5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.556,
    y: 66.3301,
    width: 54.1538,
    height: 39.3846,
    rx: 3.38462,
    transform: "rotate(-4 123.556 66.3301)",
    fill: "#2D2F5F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 143.663,
    y: 106.872,
    width: 19.6923,
    height: 3.69231,
    rx: 1.84615,
    transform: "rotate(-4 143.663 106.872)",
    fill: "#2D2F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.123 72.0391L173.413 91.2199",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.668 94.1387L171.867 69.1198",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.554,
    y: 32.8164,
    width: 9.84615,
    height: 25.8462,
    transform: "rotate(-3 114.554 32.8164)",
    fill: "#2D2F5F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3994,
    y: 14.3096,
    width: 54.1539,
    height: 39.3846,
    rx: 3.38462,
    transform: "rotate(-3 91.3994 14.3096)",
    fill: "#2D2F5F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110.797,
    y: 55.1973,
    width: 19.6923,
    height: 3.69231,
    rx: 1.84615,
    transform: "rotate(-3 110.797 55.1973)",
    fill: "#2D2F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8672 20.1328L140.815 40.0662",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0264 42.2568L139.656 17.9433",
    stroke: "white",
    strokeWidth: 3.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.1289,
    y: 47.3359,
    width: 7.38462,
    height: 19.3846,
    transform: "rotate(-8 62.1289 47.3359)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6201,
    y: 35.0225,
    width: 40.6154,
    height: 29.5385,
    rx: 2.53846,
    transform: "rotate(-8 43.6201 35.0225)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.7852,
    y: 64.3027,
    width: 14.7692,
    height: 2.76923,
    rx: 1.38462,
    transform: "rotate(-8 60.7852 64.3027)",
    fill: "#2D2F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.832 38.9512L82.2236 51.037",
    stroke: "white",
    strokeWidth: 2.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1455 55.4043L79.9123 34.5827",
    stroke: "white",
    strokeWidth: 2.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 89C49 87.8954 49.8954 87 51 87H71.2654C72.2607 87 73.1046 87.7319 73.2453 88.7172L76.7547 113.283C76.8954 114.268 77.7393 115 78.7346 115H179.265C180.261 115 181.105 114.268 181.245 113.283L184.755 88.7172C184.895 87.7319 185.739 87 186.735 87H207C208.105 87 209 87.8954 209 89V115V141C209 142.105 208.105 143 207 143H177H81H51C49.8954 143 49 142.105 49 141V115V89Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 50.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.5,
    cy: 48.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 9.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 21 147)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229 21L242.5 14.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 79L238 82",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L37.5 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 82L40 78.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(156.854 11) rotate(6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(80.5088 61) rotate(9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(39 28.6807) rotate(-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveScreenFreeMeals);
export default __webpack_public_path__ + "static/media/collective-screen-free-meals.775abc6b9860610e6e884bf04c74852c.svg";
export { ForwardRef as ReactComponent };